import settings from '../data/get-settings';

class URLResolver {

	static getCurrentEnvironment(){
		return settings.defaultEnvironment;
	}

	static getRemoteURL(){
		return settings.environments[settings.defaultEnvironment].remoteUrl;
	}

	static getUpdatedURLwithParams(url,paramsMap){
		let i=0;
		var tempString = [];
		var obj = {};
		paramsMap.forEach(function(value, key) {
			/*if(i==0){
				tempString='?'+key+'='+value;
			}else {
				tempString=tempString+'&'+key+'='+value;
			}
			i++;
			*/
			obj[key] = value;
			
  		});
  		//url=url+tempString;
  		//return url;
  		return obj;
	}

	static getParameterByName(name, url) {
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
  	}


}

export default URLResolver;